var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRevert = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.736 3.52a5.25 5.25 0 0 0-6.41.73H5.5a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 1.75 5V2a.75.75 0 0 1 1.5 0v1.204A6.75 6.75 0 1 1 1.25 8a.75.75 0 0 1 1.5 0 5.25 5.25 0 1 0 7.986-4.48z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRevert);
export default ForwardRef;